import { render, staticRenderFns } from "./AssetTypeImage.vue?vue&type=template&id=7042968a&"
import script from "./AssetTypeImage.vue?vue&type=script&lang=js&"
export * from "./AssetTypeImage.vue?vue&type=script&lang=js&"
import style0 from "./AssetTypeImage.vue?vue&type=style&index=0&id=7042968a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports